<div class="star_ratings">
    @for (_ of [].constructor(5); track $index; let i = $index) {
        <span class="star" [ngClass]="{'full_star': rating >= i + 1, 'empty_star': rating < i + 1}"></span>
    }
</div>